export default {
  scenes: {
    weightOfSilence: {
      beats: {
        firstFewDays: {
          events: [
            {
              type: 'showLocation',
              locationId: 'hotelRoom'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'sad',
              position: 'center'
            },
            {
              type: 'showNarration',
              text: 'Reina spends her days in a haze—checking her phone out of habit, replaying conversations in her mind. But no message comes. No explanation. Just silence.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'How does Reina cope?',
              choices: [
                {
                  text: 'Delete His Messages',
                  next: {
                    scene: 'weightOfSilence',
                    beat: 'deleteMessages'
                  }
                },
                {
                  text: 'Write in Her Journal',
                  next: {
                    scene: 'weightOfSilence',
                    beat: 'writeJournal'
                  }
                }
              ]
            }
          ]
        },
        deleteMessages: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'This won\'t bring him back.'
            },
            {
              type: 'showNarration',
              text: 'She deletes their chat history, leaving no trace.'
            },
            {
              type: 'showEffect',
              effect: 'flash',
              color: '#ffffff',
              duration: 0.5,
              waitUntilFinish: true
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'It\'s done.'
            },
            {
              type: 'showEffect',
              effect: 'vignette',
              intensity: 0.5
            }
          ],
          next: {
            scene: 'weightOfSilence',
            beat: 'stepForward'
          }
        },
        writeJournal: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'Maybe I just need to get it out of my head.'
            },
            {
              type: 'showNarration',
              text: 'She spills her thoughts onto paper, trying to make sense of it all.'
            },
            {
              type: 'showEffect',
              effect: 'motionLines',
              rotation: 0,
              duration: 2,
              waitUntilFinish: true
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'It still hurts, but at least it\'s not all bottled up inside anymore.'
            }
          ],
          next: {
            scene: 'weightOfSilence',
            beat: 'stepForward'
          }
        },
        stepForward: {
          events: [
            {
              type: 'showNarration',
              text: 'It still hurts, but she\'s starting to accept that some things don\'t have answers. Some people just leave.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: 'Maybe this is what moving on feels like.'
            },
            {
              type: 'hideEffect',
              effect: 'vignette'
            }
          ],
          next: {
            scene: 'rebuildingHerself',
            beat: 'newFocus'
          }
        }
      }
    },
    rebuildingHerself: {
      beats: {
        newFocus: {
          events: [
            {
              type: 'showLocation',
              locationId: 'newCafe'
            },
            {
              type: 'showNarration',
              text: 'Weeks pass. Reina throws herself into work, into hobbies, into anything that reminds her that she is more than the love she didn\'t get back.'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'What does Reina focus on?',
              choices: [
                {
                  text: 'Her Career',
                  next: {
                    scene: 'rebuildingHerself',
                    beat: 'focusCareer'
                  }
                },
                {
                  text: 'Personal Growth',
                  next: {
                    scene: 'rebuildingHerself',
                    beat: 'focusPersonalGrowth'
                  }
                }
              ]
            }
          ]
        },
        focusCareer: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'I\'ve worked too hard to let this throw me off track.'
            },
            {
              type: 'showNarration',
              text: 'She starts a new project, pouring herself into something meaningful.'
            },
            {
              type: 'showEffect',
              effect: 'motionLines',
              rotation: -15,
              duration: 1,
              waitUntilFinish: true
            }
          ],
          next: {
            scene: 'rebuildingHerself',
            beat: 'smallVictories'
          }
        },
        focusPersonalGrowth: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'Maybe it\'s time to take care of myself for once.'
            },
            {
              type: 'showNarration',
              text: 'She starts a new routine—reading, exercising, cooking for herself again.'
            },
            {
              type: 'showEffect',
              effect: 'fallingLeaves',
              color: '#98FB98',
              count: 20,
              duration: 2,
              waitUntilFinish: true
            }
          ],
          next: {
            scene: 'rebuildingHerself',
            beat: 'smallVictories'
          }
        },
        smallVictories: {
          events: [
            {
              type: 'showNarration',
              text: 'One day, Reina realizes she went a whole day without thinking about him. It\'s small, but it\'s something.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'I\'m getting there.'
            }
          ],
          next: {
            scene: 'finalGoodbye',
            beat: 'lastTimeChecks'
          }
        }
      }
    },
    finalGoodbye: {
      beats: {
        lastTimeChecks: {
          events: [
            {
              type: 'showLocation',
              locationId: 'hotelRoom'
            },
            {
              type: 'showNarration',
              text: 'One night, Reina finds herself scrolling through her photos. She hesitates on a picture of them from Bali. She hasn\'t looked at it in weeks.'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'What does Reina do?',
              choices: [
                {
                  text: 'Keep It',
                  next: {
                    scene: 'finalGoodbye',
                    beat: 'keepPhoto'
                  }
                },
                {
                  text: 'Delete It',
                  next: {
                    scene: 'finalGoodbye',
                    beat: 'deletePhoto'
                  }
                }
              ]
            }
          ]
        },
        keepPhoto: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'sad',
              text: 'It was still real. Even if it\'s over.'
            },
            {
              type: 'showNarration',
              text: 'She tucks the photo away, not as a wound, but as a memory.'
            }
          ],
          next: {
            scene: 'finalGoodbye',
            beat: 'acceptance'
          }
        },
        deletePhoto: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: 'This isn\'t who I am anymore.'
            },
            {
              type: 'showNarration',
              text: 'She presses delete. The past is gone.'
            },
            {
              type: 'showEffect',
              effect: 'flash',
              color: '#ffffff',
              duration: 0.5,
              waitUntilFinish: true
            }
          ],
          next: {
            scene: 'finalGoodbye',
            beat: 'acceptance'
          }
        },
        acceptance: {
          events: [
            {
              type: 'showNarration',
              text: 'For the first time in a long time, she feels… lighter. There is no dramatic revelation, no sudden peace. Just the quiet understanding that she survived this.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'I made it through.'
            }
          ],
          next: {
            scene: 'movingOn',
            beat: 'newBeginning'
          }
        }
      }
    },
    movingOn: {
      beats: {
        newBeginning: {
          events: [
            {
              type: 'showLocation',
              locationId: 'newCafe'
            },
            {
              type: 'showNarration',
              text: 'Months later, Reina sits at a new café in a new city. She\'s working on something exciting—something that\'s hers.'
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'What is she doing?',
              choices: [
                {
                  text: 'Planning Her Own Business',
                  next: {
                    scene: 'movingOn',
                    beat: 'planningBusiness'
                  }
                },
                {
                  text: 'Traveling Again',
                  next: {
                    scene: 'movingOn',
                    beat: 'travelingAgain'
                  }
                }
              ]
            }
          ]
        },
        planningBusiness: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'This time, I\'m building something for me.'
            },
            {
              type: 'showNarration',
              text: 'She sketches out ideas for her own company.'
            },
            {
              type: 'showEffect',
              effect: 'motionLines',
              rotation: 0,
              duration: 1,
              waitUntilFinish: true
            }
          ],
          next: {
            scene: 'movingOn',
            beat: 'hopeReturns'
          }
        },
        travelingAgain: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'There\'s so much I haven\'t seen yet.'
            },
            {
              type: 'showNarration',
              text: 'She books her next trip, excited to explore on her own terms.'
            },
            {
              type: 'showEffect',
              effect: 'fallingLeaves',
              color: '#87CEEB',
              count: 20,
              duration: 2,
              waitUntilFinish: true
            }
          ],
          next: {
            scene: 'movingOn',
            beat: 'hopeReturns'
          }
        },
        hopeReturns: {
          events: [
            {
              type: 'showNarration',
              text: 'Reina has changed. She is no longer waiting for closure from someone else. She made her own.'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: 'I think I\'m happy again.'
            },
            {
              type: 'showNarration',
              text: 'THE END.'
            }
          ],
          goToGameOver: true
        }
      }
    }
  }
}
